import { legacy } from '@/shared/api/client';

export interface CouponSettings {
  hasCoupons: boolean;
  /** Ausente não mexe no salvo; '' apaga. */
  couponName?: string;
  couponStoreUrl?: string;
}

/** Persiste o módulo de cupons da loja (PUT /passbook/:id/coupons). */
export async function updateCouponSettings(idPassbook: string, settings: CouponSettings): Promise<void> {
  await legacy.put<{ ok: boolean }>(
    `/passbook/${idPassbook}/coupons`,
    settings,
    { headers: { 'X-Passbook-Id': idPassbook } },
  );
}
